module.exports = __webpack_public_path__ + "img/764-87d7a2.png";